import HttpClient, { HttpClientConfig} from 'axios-mapper'
import i18n from '@/locales/index'
import axios from 'axios'
let baseURL = ''
let api_config: any = {}
import store  from '@/store'
import { ElMessage } from 'element-plus'



let http_config_datas: any = {}
const { t } = i18n.global

const getQueryString = (name: string) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  if (window.location.href.indexOf('?') < 0) {
    return null
  }
  const r = window.location.href.split('?')[1].match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null
}

const request = (base_url?: string) => {
  const token = getQueryString('token') || store.getters.token
  const api_config = getApiConfig()

  const baseUrlArr = [api_config.liteSellerUrl, api_config.liteAdminUrl]
  const boo = baseUrlArr.includes(base_url)
  const headersAuthorTex = boo ? 'AccessToken' : 'Authorization'
  const config: HttpClientConfig = {
    baseURL: base_url || baseURL,
    headers: {
      [headersAuthorTex]: boo ? token : 'Bearer ' + token,
      // 'x-authenticated-userid':1
    }
  }
  const https = new HttpClient(config)

  // Add a request interceptor
  https.httpClient.interceptors.request.use(function (config) {
    // Do something before request is sent
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

  // Add a response interceptor
  https.httpClient.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
  }, function (error) {

    const errMsg = error.toString()
    const code = errMsg.substr(errMsg.indexOf('code') + 5)
    if(code == '401') {
      store.dispatch('clearToken')
      ElMessage({
          message: t("goodsManage.Notlogged"),
          duration: 2000,
          type: 'error'
      })
    }
    // Do something with response error
    return Promise.reject(error);
  });

  return https
}

const getApiConfig = () => {
  if(sessionStorage.getItem('http_config_datas') && baseURL === '') {
    let data_str: string = sessionStorage.getItem('http_config_datas') || '{}'
    http_config_datas = JSON.parse(data_str)
    baseURL = http_config_datas.bserUrl
    api_config = http_config_datas
  }
  return api_config
}
export default request
export { getApiConfig,getQueryString  }

